// An empty string uses the Vite proxy or the same-origin production API.
export const BIRDBRAIN_API_BASE_URL =
  typeof import.meta.env.VITE_BIRDBRAIN_API_URL === 'string'
    ? import.meta.env.VITE_BIRDBRAIN_API_URL
    : 'http://localhost:3001'
